import moment, { Moment } from "moment";
import { SignalsTemporalLabels } from "../SignalsModels";

export const THE_MICHAEL_GRAIN = 12;

export function temporalGrain(
    startDate: Moment,
    endDate: Moment,
): SignalsTemporalLabels {
    const utcStartDate = moment.utc(startDate);
    const utcEndDate = moment.utc(endDate);
    const daysInRange = utcEndDate.diff(utcStartDate, "days");

    if (daysInRange <= THE_MICHAEL_GRAIN) {
        return "Daily";
    }
    const weeksInRange = utcEndDate.diff(utcStartDate, "weeks");

    if (weeksInRange <= THE_MICHAEL_GRAIN) {
        return "Weekly";
    }

    // Match the backend Michael grain calculation, which uses the UTC request date range.
    const monthsInRange = utcEndDate
        .clone()
        .diff(utcStartDate.clone().startOf("M"), "months");

    if (monthsInRange < THE_MICHAEL_GRAIN) {
        return "Monthly";
    }

    return "Quarterly";
}
